import type { LayerDefinition, LayerId } from './model';

/**
 * Return project layers in a new top-to-bottom order while retaining every
 * layer object (and therefore its source/style references) by identity.
 */
export function reorderLayers(
  layers: readonly LayerDefinition[],
  layerId: LayerId,
  targetIndex: number,
): readonly LayerDefinition[] {
  if (!Number.isInteger(targetIndex) || targetIndex < 0 || targetIndex >= layers.length) {
    return layers;
  }

  const currentIndex = layers.findIndex((layer) => layer.id === layerId);
  if (currentIndex < 0 || currentIndex === targetIndex) return layers;

  const reordered = [...layers];
  const [layer] = reordered.splice(currentIndex, 1);
  if (!layer) return layers;
  reordered.splice(targetIndex, 0, layer);
  return reordered;
}
